import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,_vm._b({staticClass:"vd-download-btn",attrs:{"loading":_vm.state === _vm.StateEnum.PENDING},nativeOn:{"click":function($event){return _vm.download.apply(null, arguments)}}},'VBtn',_vm.btnOptions,false),[_vm._t("icon",function(){return [_c(VIcon,_vm._b({},'VIcon',_vm.options.icon,false),[_vm._v(" "+_vm._s(_vm.downloadIcon)+" ")])]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }